// WAENN — Lightbox/carrusel fullscreen para las imagenes del PDP. Se abre al
// hacer click (o Enter/Espacio) en cualquier imagen de la galeria
// (.waenn-pdp__gallery-item[data-waenn-lightbox-open]) y muestra TODAS las
// imagenes del producto (mismo orden que la galeria), con swipe (Pointer
// Events: touch y raton), flechas, flechas de teclado, columna de
// miniaturas clicables (escritorio), contador de posicion, y cierre con
// Escape, boton de cerrar o click fuera de la imagen. Vease
// snippets/waenn-image-lightbox.liquid.

(function () {
  function waennInitLightbox(root) {
    var sectionId = root.dataset.section;
    var lightbox = document.getElementById('WaennLightbox-' + sectionId);
    if (!lightbox || lightbox.dataset.waennLightboxReady) return;

    var track = lightbox.querySelector('[data-waenn-lightbox-track]');
    var slides = Array.prototype.slice.call(
      lightbox.querySelectorAll('[data-waenn-lightbox-slide]')
    );
    var closeBtn = lightbox.querySelector('[data-waenn-lightbox-close]');
    var backdrop = lightbox.querySelector('[data-waenn-lightbox-backdrop]');
    var prevBtn = lightbox.querySelector('[data-waenn-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-waenn-lightbox-next]');
    var currentEl = lightbox.querySelector('[data-waenn-lightbox-current]');
    var thumbs = Array.prototype.slice.call(
      lightbox.querySelectorAll('[data-waenn-lightbox-thumb]')
    );
    var triggers = Array.prototype.slice.call(
      root.querySelectorAll('[data-waenn-lightbox-open]')
    );

    if (!track || !slides.length || !triggers.length) return;
    lightbox.dataset.waennLightboxReady = 'true';

    var total = slides.length;
    var currentIndex = 0;
    var isOpen = false;
    var lastFocused = null;

    function focusableElements() {
      return Array.prototype.slice
        .call(
          lightbox.querySelectorAll(
            'button, [href], [tabindex]:not([tabindex="-1"])'
          )
        )
        .filter(function (el) {
          return !el.hidden && el.offsetParent !== null;
        });
    }

    function setActiveThumb(index) {
      if (!thumbs.length) return;
      thumbs.forEach(function (thumb) {
        var thumbIndex = parseInt(thumb.dataset.index, 10);
        if (thumbIndex === index) {
          thumb.classList.add('is-active');
          thumb.scrollIntoView({ block: 'nearest' });
        } else {
          thumb.classList.remove('is-active');
        }
      });
    }

    function goTo(index, animate) {
      currentIndex = ((index % total) + total) % total;
      var offset = -currentIndex * 100;
      if (animate === false) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + offset + '%)';
        void track.offsetHeight;
        track.style.transition = '';
      } else {
        track.style.transform = 'translateX(' + offset + '%)';
      }
      if (currentEl) currentEl.textContent = String(currentIndex + 1);
      setActiveThumb(currentIndex);
    }

    function open(index) {
      lastFocused = document.activeElement;
      isOpen = true;
      goTo(index, false);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function next() {
      goTo(currentIndex + 1);
    }

    function prev() {
      goTo(currentIndex - 1);
    }

    function onKeydown(e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        close();
      } else if (e.key === 'ArrowRight') {
        next();
      } else if (e.key === 'ArrowLeft') {
        prev();
      } else if (e.key === 'Tab') {
        var focusable = focusableElements();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = parseInt(trigger.dataset.waennLightboxIndex, 10) || 0;
        open(index);
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          var index = parseInt(trigger.dataset.waennLightboxIndex, 10) || 0;
          open(index);
        }
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.dataset.index, 10) || 0;
        goTo(index);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var startTime = 0;
    var dragging = false;
    var lockedAxis = null;
    var justDragged = false;

    function onPointerDown(e) {
      if (!isOpen) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      deltaX = 0;
      startTime = Date.now();
      dragging = true;
      lockedAxis = null;
      track.style.transition = 'none';
      if (track.setPointerCapture) {
        try {
          track.setPointerCapture(pointerId);
        } catch (err) {
          /* noop */
        }
      }
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!lockedAxis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        lockedAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (lockedAxis !== 'x') return;

      e.preventDefault();
      deltaX = dx;
      var slideWidth = track.clientWidth || 1;
      var percentDelta = (deltaX / slideWidth) * 100;
      var baseOffset = -currentIndex * 100;
      var resisted = percentDelta;
      if (
        (currentIndex === 0 && deltaX > 0) ||
        (currentIndex === total - 1 && deltaX < 0)
      ) {
        resisted = percentDelta / 3;
      }
      track.style.transform = 'translateX(' + (baseOffset + resisted) + '%)';
    }

    function onPointerUp(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      dragging = false;
      track.style.transition = '';

      if (lockedAxis === 'x') {
        var elapsed = Date.now() - startTime || 1;
        var velocity = deltaX / elapsed;
        var slideWidth = track.clientWidth || 1;
        var distanceRatio = deltaX / slideWidth;

        if (Math.abs(deltaX) > 5) justDragged = true;

        if (distanceRatio < -0.18 || velocity < -0.5) {
          next();
        } else if (distanceRatio > 0.18 || velocity > 0.5) {
          prev();
        } else {
          goTo(currentIndex);
        }
      }
      pointerId = null;
      lockedAxis = null;
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);

    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    track.addEventListener('click', function (e) {
      if (justDragged) {
        justDragged = false;
        return;
      }
      if (
        e.target === track ||
        (e.target.classList && e.target.classList.contains('waenn-lightbox__slide'))
      ) {
        close();
      }
    });

    window.addEventListener('resize', function () {
      if (isOpen) goTo(currentIndex, false);
    });
  }

  function waennInit() {
    document.querySelectorAll('product-info.waenn-pdp').forEach(function (root) {
      waennInitLightbox(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waennInit);
  } else {
    waennInit();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var root =
        event.target && event.target.querySelector
          ? event.target.querySelector('product-info.waenn-pdp')
          : null;
      if (root) waennInitLightbox(root);
    });
  }
})();
